module.exports = __webpack_public_path__ + "app/heySpace/favicons/unreadNotifications.png";